// Support pop-up tracking — DASH-6570 R1 AC 4.
// web-public has no analytics SDK yet, so events go onto window.dataLayer, the
// shape GTM / GA4 read. Until a tag is added to the page they are collected but
// not sent anywhere.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export type SupportChannel = "call" | "whatsapp" | "chat" | "hotel_call";

export interface ISupportEventContext {
  hotelBooking: boolean;
  pageLanguage: "en" | "zh";
}

const push = (event: string, props: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...props });
};

const common = (ctx: ISupportEventContext) => ({
  hotel_booking: ctx.hotelBooking ? "yes" : "no",
  page_language: ctx.pageLanguage,
});

export const trackSupportOpen = (ctx: ISupportEventContext) =>
  push("web_receipt_support_open", common(ctx));

export const trackSupportContactTap = (
  channel: SupportChannel,
  ctx: ISupportEventContext
) => push("web_receipt_support_contact_tap", { channel, ...common(ctx) });
